import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";
import CountUp from "react-countup";
import Header from "../header";
import "./eighteenNineteen.css";

export default class EighteenNineteen extends Component {
  constructor(props) {
    super(props);
    this.state = {player: "", ballsLostOverFences: 29};

    this.handlePlayerChange = this.handlePlayerChange.bind(this);
  }

  handlePlayerChange(event) {
    this.setState({player: event.target.value, ballsLostOverFences: event.target.value === 'colmmcnabola' ? 3867283 : 29});
  }

  transformNameToKey(name) {
    return name.toLocaleLowerCase().replace(" ", "").replace("'", "")
  }

  renderStatistics(statistics, statisticIndex) {
    return (
      <Grid key={statisticIndex} fluid className="statistics">
        {statistics.map((statistic, i) => (
          <Row key={i} className="statistic">
            <Col xs={4} md={4} mdOffset={1} className="measure">
              <span>
                <CountUp
                  end={statistic.measure}
                  separator=","
                  duration={statistic.measure > 500000 ? 8 : 1}
                  delay={statisticIndex + i / 3}
                />
              </span>
            </Col>
            <Col xs={8} md={6} className="description">
              <div className="emoji">
                <span>{statistic.emoji}</span>
              </div>
              <span>{statistic.measure === 1 && statistic.singularDescription ? statistic.singularDescription : statistic.description}</span>
            </Col>
          </Row>
        ))}
      </Grid>
    );
  }

  render() {
    const eventStatistics = [
      {
        measure: 12,
        emoji: "👬",
        description: "Friendlies"
      },
      {
        measure: 33,
        emoji: "🏋️‍♂️",
        description: "Training Sessions"
      },
      {
        measure: 44,
        emoji: "🏟",
        description: "League Games"
      }
    ];
    const attendanceStatistics = [
      {
        measure: 96,
        emoji: "🏃‍♂️",
        description: "Players"
      },
      {
        measure: 1369,
        emoji: "🙋‍♂️",
        description: "Attendances"
      },
      {
        measure: 123210,
        emoji: "⏱",
        description: "Minutes of football"
      }
    ];
    const matchStatistics = [
      {
        measure: 19,
        emoji: "🏆",
        description: "Wins"
      },
      {
        measure: 6,
        emoji: "😐",
        description: "Draws"
      },
      {
        measure: 17,
        emoji: "👎",
        description: "Loses"
      }
    ];
    const miscStatistics = [
      {
        measure: 4,
        emoji: "🤮",
        description: "Sick Notes"
      },
      {
        measure: this.state.ballsLostOverFences,
        emoji: "🚀",
        description: "Lost Balls"
      }
    ];
    const allPlayerStatistics = [
      {name: "Ahmed LB", goals: 1, motm: 0, friendly: 5, league: 8, training: 20, friends: 74, strangers: 3}, 
      {name: "Alex Wray", goals: 4, motm: 1, friendly: 1, league: 16, training: 15, friends: 81, strangers: 3}, 
      {name: "Alexander Cox", goals: 4, motm: 0, friendly: 6, league: 16, training: 15, friends: 75, strangers: 2}, 
      {name: "André Rohan Jackson", goals: 0, motm: 0, friendly: 1, league: 0, training: 2, friends: 36, strangers: 33}, 
      {name: "Andy Rose", goals: 9, motm: 6, friendly: 3, league: 8, training: 1, friends: 49, strangers: 22}, 
      {name: "Andy U Young", goals: 1, motm: 0, friendly: 3, league: 7, training: 3, friends: 57, strangers: 8}, 
      {name: "Antonio Murugesan", goals: 0, motm: 1, friendly: 1, league: 13, training: 10, friends: 77, strangers: 2}, 
      {name: "Ardit Korbi", goals: 38, motm: 1, friendly: 7, league: 25, training: 24, friends: 90, strangers: 0}, 
      {name: "Bassie Oldham", goals: 0, motm: 0, friendly: 0, league: 0, training: 5, friends: 41, strangers: 19}, 
      {name: "Callum Goodridge", goals: 0, motm: 0, friendly: 6, league: 10, training: 24, friends: 76, strangers: 1}, 
      {name: "Carlos Tineo", goals: 0, motm: 0, friendly: 3, league: 5, training: 17, friends: 60, strangers: 40}, 
      {name: "Chris Deeley", goals: 0, motm: 0, friendly: 1, league: 0, training: 4, friends: 54, strangers: 21}, 
      {name: "Chris Loudon", goals: 0, motm: 0, friendly: 1, league: 1, training: 0, friends: 20, strangers: 43}, 
      {name: "Chris WY", goals: 0, motm: 0, friendly: 2, league: 0, training: 9, friends: 43, strangers: 16}, 
      {name: "Colm Mcnabola", goals: 4, motm: 2, friendly: 5, league: 12, training: 14, friends: 74, strangers: 1}, 
      {name: "Connor Dyer", goals: 0, motm: 0, friendly: 2, league: 4, training: 4, friends: 67, strangers: 14}, 
      {name: "Danny Jones", goals: 0, motm: 0, friendly: 2, league: 10, training: 12, friends: 65, strangers: 7}, 
      {name: "Darwing Carvajal", goals: 5, motm: 0, friendly: 2, league: 8, training: 0, friends: 44, strangers: 21}, 
      {name: "Dre Oduye", goals: 1, motm: 0, friendly: 5, league: 12, training: 17, friends: 68, strangers: 1}, 
      {name: "Elliott Pearse", goals: 1, motm: 0, friendly: 2, league: 9, training: 16, friends: 78, strangers: 7}, 
      {name: "Gad Harari", goals: 0, motm: 0, friendly: 1, league: 1, training: 4, friends: 62, strangers: 13}, 
      {name: "Garbo Kwok", goals: 0, motm: 0, friendly: 2, league: 0, training: 6, friends: 44, strangers: 17}, 
      {name: "Gareth Stephens", goals: 0, motm: 0, friendly: 7, league: 24, training: 25, friends: 92, strangers: 0}, 
      {name: "Gino Murugesan", goals: 1, motm: 3, friendly: 3, league: 19, training: 11, friends: 81, strangers: 1}, 
      {name: "Glenn Pearson", goals: 0, motm: 0, friendly: 0, league: 4, training: 6, friends: 52, strangers: 13}, 
      {name: "Ian Pocock", goals: 0, motm: 0, friendly: 6, league: 15, training: 21, friends: 90, strangers: 1}, 
      {name: "Ibrahim El-berkati", goals: 0, motm: 0, friendly: 1, league: 0, training: 2, friends: 43, strangers: 24}, 
      {name: "Isaac Gill", goals: 1, motm: 0, friendly: 2, league: 10, training: 25, friends: 80, strangers: 1}, 
      {name: "Jack Chen", goals: 0, motm: 0, friendly: 1, league: 0, training: 10, friends: 55, strangers: 9}, 
      {name: "Jack Piper", goals: 0, motm: 0, friendly: 1, league: 0, training: 5, friends: 40, strangers: 21}, 
      {name: "Jacob Cubitt", goals: 0, motm: 0, friendly: 3, league: 7, training: 16, friends: 54, strangers: 8}, 
      {name: "Jaime Randall", goals: 2, motm: 2, friendly: 7, league: 22, training: 22, friends: 90, strangers: 0}, 
      {name: "James Greveson Hickie", goals: 0, motm: 0, friendly: 1, league: 3, training: 3, friends: 53, strangers: 15}, 
      {name: "Jay Hall", goals: 0, motm: 0, friendly: 3, league: 13, training: 0, friends: 51, strangers: 19}, 
      {name: "Jim Pomeroy", goals: 2, motm: 2, friendly: 2, league: 13, training: 1, friends: 42, strangers: 28}, 
      {name: "Joe Wilson", goals: 3, motm: 0, friendly: 1, league: 4, training: 0, friends: 37, strangers: 25}, 
      {name: "Jonny Dundon", goals: 1, motm: 1, friendly: 1, league: 4, training: 5, friends: 56, strangers: 14}, 
      {name: "Jordan Sullivan", goals: 0, motm: 0, friendly: 2, league: 0, training: 7, friends: 41, strangers: 19}, 
      {name: "Joseph Lamb", goals: 0, motm: 0, friendly: 0, league: 0, training: 2, friends: 33, strangers: 27}, 
      {name: "Josh Lambert", goals: 0, motm: 0, friendly: 0, league: 0, training: 8, friends: 44, strangers: 17}, 
      {name: "Lawrence O'Leary", goals: 0, motm: 1, friendly: 0, league: 15, training: 1, friends: 41, strangers: 19}, 
      {name: "Liam Lockwood", goals: 1, motm: 1, friendly: 4, league: 10, training: 14, friends: 67, strangers: 4}, 
      {name: "Martin Nash", goals: 0, motm: 0, friendly: 3, league: 17, training: 6, friends: 71, strangers: 9}, 
      {name: "Matt Oldham", goals: 0, motm: 0, friendly: 2, league: 0, training: 6, friends: 43, strangers: 18}, 
      {name: "Michael Grover", goals: 0, motm: 0, friendly: 0, league: 2, training: 1, friends: 40, strangers: 26}, 
      {name: "Michael Peet", goals: 4, motm: 4, friendly: 6, league: 22, training: 27, friends: 91, strangers: 1}, 
      {name: "Michael Tew", goals: 1, motm: 3, friendly: 1, league: 12, training: 11, friends: 75, strangers: 4}, 
      {name: "Mike Hub", goals: 0, motm: 0, friendly: 0, league: 0, training: 3, friends: 43, strangers: 25}, 
      {name: "Nat Houghton", goals: 1, motm: 1, friendly: 2, league: 7, training: 15, friends: 72, strangers: 4}, 
      {name: "Nicholas David Skelton", goals: 0, motm: 0, friendly: 3, league: 9, training: 15, friends: 79, strangers: 2}, 
      {name: "Oliver Peck", goals: 4, motm: 0, friendly: 7, league: 16, training: 28, friends: 93, strangers: 0}, 
      {name: "Ollie Lawson", goals: 0, motm: 0, friendly: 1, league: 2, training: 1, friends: 42, strangers: 27}, 
      {name: "Oyetola Oyewobi", goals: 2, motm: 0, friendly: 1, league: 14, training: 12, friends: 69, strangers: 5}, 
      {name: "Patrick Laredo", goals: 0, motm: 0, friendly: 1, league: 3, training: 11, friends: 78, strangers: 6}, 
      {name: "Paulo Silva", goals: 0, motm: 0, friendly: 1, league: 0, training: 2, friends: 39, strangers: 29}, 
      {name: "Peter Doyle", goals: 6, motm: 2, friendly: 5, league: 20, training: 26, friends: 85, strangers: 2}, 
      {name: "Robert Blade", goals: 0, motm: 0, friendly: 2, league: 0, training: 3, friends: 50, strangers: 19}, 
      {name: "Ronit Patel", goals: 0, motm: 0, friendly: 4, league: 6, training: 19, friends: 78, strangers: 3}, 
      {name: "Ross Farquharson", goals: 0, motm: 0, friendly: 1, league: 3, training: 2, friends: 46, strangers: 18}, 
      {name: "Ryan Shrives", goals: 1, motm: 0, friendly: 1, league: 5, training: 2, friends: 56, strangers: 14}, 
      {name: "Santiago Rodriguez", goals: 0, motm: 0, friendly: 1, league: 1, training: 16, friends: 81, strangers: 2}, 
      {name: "Sin Dong-Han", goals: 0, motm: 0, friendly: 1, league: 0, training: 2, friends: 43, strangers: 24}, 
      {name: "Stephane Ringsell", goals: 3, motm: 0, friendly: 4, league: 11, training: 5, friends: 71, strangers: 1}, 
      {name: "Tark Djemal", goals: 0, motm: 0, friendly: 0, league: 0, training: 3, friends: 40, strangers: 21}, 
      {name: "Thomas Kær", goals: 6, motm: 0, friendly: 1, league: 3, training: 4, friends: 62, strangers: 11}, 
      {name: "Tithipong Plangsangmas", goals: 0, motm: 0, friendly: 2, league: 3, training: 7, friends: 61, strangers: 8}, 
      {name: "Wahid Cfc", goals: 0, motm: 0, friendly: 3, league: 2, training: 11, friends: 78, strangers: 2}
    ];

    var playerStatisticsRaw = this.state.player ? allPlayerStatistics.filter(x => this.transformNameToKey(x.name) === this.state.player)[0] : null;
    var playerAchievmentStatistics = [], playerEventStatistics = [], playerAttendanceStatistics = [], playerRelationshipStatistics = [];
    if(playerStatisticsRaw) {
      playerEventStatistics.push({
        measure: playerStatisticsRaw.friendly,
        emoji: "👬",
        description: "Friendlies",
        singularDescription: "Friendly"
      },
      {
        measure: playerStatisticsRaw.training,
        emoji: "🏋️‍♂️",
        description: "Training Sessions",
        singularDescription: "Training Session"
      },
      {
        measure: playerStatisticsRaw.league,
        emoji: "🏟",
        description: "League Games",
        singularDescription: "League Game"
      });

      if(playerStatisticsRaw.goals) {
        playerAchievmentStatistics.push({
          measure: playerStatisticsRaw.goals,
          emoji: "⚽",
          description: "League Goals",
          singularDescription: "League Goal"
        });
      }
      if(playerStatisticsRaw.motm) {
        playerAchievmentStatistics.push({
          measure: playerStatisticsRaw.motm,
          emoji: "🥇",
          description: "Man Of The Match"
        });
      }

      var playerAttendances = playerStatisticsRaw.friendly + playerStatisticsRaw.training + playerStatisticsRaw.league;

      playerAttendanceStatistics.push({
        measure: playerAttendances,
        emoji: "🙋‍♂️",
        description: "Attendances",
        singularDescription: "Attendance"
      },
      {
        measure: playerAttendances * 90,
        emoji: "⏱",
        description: "Minutes of football"
      })

      playerRelationshipStatistics.push({
        measure: playerStatisticsRaw.friends,
        emoji: "🤝",
        description: "Teammates Met",
        singularDescription: "Teammate Met"
      },
      {
        measure: playerStatisticsRaw.strangers,
        emoji: "❓",
        description: "Teammates Not Met",
        singularDescription: "Teammate Not Met"
      })

      if(["Carlos Tineo", "Darwing Carvajal"].includes(playerStatisticsRaw.name)) {
        playerAchievmentStatistics.push({
          measure: 1,
          emoji: "🛑",
          description: "Red Card For Swearing At The Referee In Spanish"
        });
      }

      if(["Gino Murugesan"].includes(playerStatisticsRaw.name)) {
        playerAchievmentStatistics.push({
          measure: 1,
          emoji: "🗺️",
          description: "Wrong Ground"
        });
      }

      if(["Jaime Randall", "Gareth Stephens", "Michael Tew"].includes(playerStatisticsRaw.name)) {
        playerAchievmentStatistics.unshift({
          measure: playerStatisticsRaw.name === "Michael Tew" ? 7: 9,
          emoji: "🌐",
          description: "Committee Meetings"
        });
      }

      if(playerStatisticsRaw.name === "Ardit Korbi") {
        playerAchievmentStatistics.unshift({
          measure: 1,
          emoji: "🏆",
          description: "Club Top Scorer"
        });
      }
      if(playerStatisticsRaw.name === "Peter Doyle") {
        playerAchievmentStatistics.unshift({
          measure: 1,
          emoji: "🏆",
          description: "1s Players Player"
        });
      }
      if(playerStatisticsRaw.name === "Michael Peet") {
        playerAchievmentStatistics.unshift({
          measure: 1,
          emoji: "🏆",
          description: "1s Managers Player"
        });
      }
      if(playerStatisticsRaw.name === "Dre Oduye") {
        playerAchievmentStatistics.unshift({
          measure: 1,
          emoji: "🏆",
          description: "2s Managers Player"
        },
        {
          measure: 1,
          emoji: "🏆",
          description: "2s Players Player"
        });
      }
      if(playerStatisticsRaw.name === "Oliver Peck") {
        playerAchievmentStatistics.unshift({
          measure: 1,
          emoji: "🏆",
          description: "Unsung Hero"
        });
      }
    }
    
    return (
      <Grid fluid>
        <Row>
          <Col sm={12} md={10} mdOffset={1}>
            <Header subtitle="18/19 SEASON" />
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={10} mdOffset={1}>
            <div className="intro">
              <p>Thanks for being a part of our 18/19 season!</p>
              <p>Here's what we got up to...</p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={10} mdOffset={1}>
            <div className="section">
              <p className="subheading">Club Statistics</p>
              {[eventStatistics, matchStatistics, attendanceStatistics, miscStatistics].map(
                (statistics, i) => this.renderStatistics(statistics, i)
              )}
            </div>
          </Col>
        </Row>

        <Row>
          <Col sm={12} md={10} mdOffset={1}>
            <div className="section">
              <p className="subheading">Player Statistics</p>
              <p>Select a player to view individual statistics</p>
              <div className="selectContainer">
                <select value={this.state.value} onChange={this.handlePlayerChange}>
                  <option defaultValue></option>
                  {allPlayerStatistics
                  .map(x => x.name)
                  .map((x, i) => (<option key={i} value={this.transformNameToKey(x)}>{x}</option>))}
                </select>
              </div>
            </div>
          </Col>
        </Row>

        {playerStatisticsRaw && <Row>
          <Col sm={12} md={10} mdOffset={1}>
            <div className="section">
              <p className="subheading">{playerStatisticsRaw.name} Statistics</p>
              {[playerAchievmentStatistics, playerEventStatistics, playerAttendanceStatistics, playerRelationshipStatistics]
              .filter(x => x.length)
              .map(
                (statistics, i) => this.renderStatistics(statistics, i)
              )}
              {playerStatisticsRaw.league*0.5 > playerStatisticsRaw.training &&
              <div className="trainingWarning">COME TO TRAINING MORE!</div>}
            </div>
          </Col>
        </Row>}
        <div className="spacer"></div>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/eighteenNineteen/index.js